/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-21 09:09:10
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-22 01:58:07
 * @FilePath: \H5\src\api\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "./axios";

console.log(axios)
// /chainTea/findChainInfoList
// const getDataApi = () => axios.get('/chainTea/findChainInfoList?markdetailId=1e890af05b0c4e9d836d21f6481d9f55')
const getDataApi = (markdetailId, batch_code, merchant_id, t) =>
	axios.get(
		`/chainTea/findChainInfoList?id=${markdetailId}&batch_Code=${batch_code}&merchant_id=${merchant_id}&t=${t}`
	);
const getQuery = (id) =>
	axios.get(`/chainTea/checkCode?markdetailId=${id}&txid=`);
console.log(getDataApi)


export default {
	getDataApi,
	getQuery,
};
